import React from 'react';
import dataModel from '../../models/DataModel';
import { connect } from 'react-redux';
import _ from 'lodash';
import AnalyticsLogger from '../../helpers/analytics/analyticsLogger';
import BaseComponent from '../../baseClasses/BaseComponent';
import anime from 'animejs';
import cancelIcon from '../../assets/images/close-icon.svg';
import DataSource from '../../dao/DataSource/DataSource';
import SelectUserComboBox from '../../components/SelectUserComboBox';
import PhotoCarousel from '../../components/PhotoCarousel';
import userService from '../../services/userService';

import './DeactivateUserPopup.scss';
import { teamAssignedProjects } from '../../helpers/teamAssignedProjects';

const teamDescriptor = { team: { lead_user: {}, users: {}, markets: { company: {}, vendor_users: { role: {} }, users: { role: {} } } } };

class DeactivateUserPopup extends BaseComponent {
 
  constructor(props) {
    super(props);
    this.state = {
      markets: null,
      selectedMarkets: null,
      team: { name: '', logo: null, markets: [], lead_user: null },
      selectedTabName: 'deactivate user',
      deactivate: false,
      replace: null,
      editedContact: Object.assign({}),
      changed: false,
      editUser: this.props.currentUser,
      newUser: 0,
      newUser_rol: 'none',
      usersShareSameMarket: null,
    };

    this.closePopup = this.closePopup.bind(this);
    this.collapsePopup = this.collapsePopup.bind(this);
    this.changeTeamName = this.changeTeamName.bind(this);
    this.showLogoPopup = this.showLogoPopup.bind(this);
    this.setTeamLogo = this.setTeamLogo.bind(this);
    this.deleteTeamLogo = this.deleteTeamLogo.bind(this);
    this.setMarketUsers = this.setMarketUsers.bind(this);
    this.queryCloseWithoutSave = this.queryCloseWithoutSave.bind(this);
    this.closeLogoPopup = this.closeLogoPopup.bind(this);
    this.marketsEqual = this.marketsEqual.bind(this);
    this.projectsEqual = this.projectsEqual.bind(this);

    this.tabs = ['deactivate user', 'confirm deactivation', 'users'];
    if (!props.teamId) {
      this.disabledTabs = ['confirm deactivation', 'users'];
    }

  }

  handleCompanyRetrieval(company) {
    if (company) {
      this.setState({ company, markets: company.markets });
    }
  }

  handleTeamRetrieval(team, action, acData, fetchedData) {
    if (action == 'create') {
      this.teamDataSource = new DataSource('Team', team.id, teamDescriptor, this.handleTeamRetrieval);
      this.disabledTabs = ['users'];
      this.setState({
        team, selectedTabName: 'confirm deactivation', active: false, nameChanged: false,
        leadChanged: false, logoChanged: false, marketsChanged: false,
      });
      this.teamDataSource.get();
    }
    else if (action == 'update') {
      return;
    }
    else if (fetchedData) {
      this.setState({ team: fetchedData, updatedTeamUsers: null });
    }
    else {
      const assigned = teamAssignedProjects(team);
      let selectedProjects = assigned.length ? assigned.map(project => { return project.id; }) : [];
      this.setState({ selectedProjects, team, originalMarkets: team.markets ? team.markets.map(m => { return m; }) : [] });
      if (!this.state.originalTeam) {
        this.setState({ originalTeam: _.cloneDeep(team) });
      }
      this.setMarketUsers(team.markets);
    }
  }

  marketsEqual(markets1, markets2) {
    if (!markets1 || !markets2) {
      return false;
    }
    if (markets1.length != markets2.length) {
      return false;
    }
    else {
      markets2.forEach(market2 => {
        if (!markets1.find(market1 => { return market1.id == market2.id; })) {
          return false;
        }
      });
      return true;
    }
  }

  projectsEqual(project1Ids, projects2) {
    if (!project1Ids || !projects2) {
      return false;
    }
    if (project1Ids.length != projects2.length) {
      return false;
    }
    else {
      projects2.forEach(project2 => {
        if (!project1Ids.find(project1Id => { return project1Id == project2.id; })) {
          return false;
        }
      });
      return true;
    }
  }

  handleAdvance(back) {
    const { team, active } = this.state;
    switch (this.state.selectedTabName) {
    case 'deactivate user':
      if (!this.props.teamId) {
        if (back) {
        }
        else {
          this.setState({ selectedTabName: 'confirm deactivation', active: this.state.updatedTeamUsers || (team.users && team.users.length > 0) });
        }
      }
      else {
        this.setState({ active });
      }
      break;
    case 'confirm deactivation':
      if (!this.props.teamId) {
        if (back) {
          this.setState({ selectedTabName: 'deactivate user', active: true });
        }
        else {
          this.disabledTabs = [];
          this.setState({ selectedTabName: 'users', active: true });
        }
      }
      else {
        this.setState({ active });
      }
      break;
    case 'users': 
      if (!this.props.teamId) {
        if (back) {
          this.setState({ selectedTabName: 'confirm deactivation', active: true });
        }
        else {
          this.closePopup();
        }
      }
      else {
        this.setState({ active });
      }
      break;
    default:
      break;
    }
  }

  componentDidMount() {
    dataModel.setDisableAppBackground(true);
    this.popupCaption = 'DEACTIVATE USER';
   
    const currentRole = this.props.currentUser ? this.props.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });

    this.companyDataSource = new DataSource('Company', this.props.currentCompany.id, {
      company: {
        markets: {
          users: { additionalFields: ['profile_image'], role: {} },
          vendor_users: { additionalFields: ['profile_image'], role: {} },
        },
      },
    },
     
    this.handleCompanyRetrieval);
    this.companyDataSource.get();

    this.setUsersWhoShareSameMarket(this.props.currentUser);
  }

  componentWillUnmount() {
    if (this.companyDataSource) {
      this.companyDataSource.release();
      this.companyDataSource = null;
    }
    if (this.teamDataSource) {
      this.teamDataSource.release();
      this.teamDataSource = null;
    }
  }

  componentDidUpdate(prevProps) {
  }

  handleDeleteLogo() {
    let { team } = this.state;
    this.closeLogoPopup();
    if (this.teamDataSource) {
      this.teamDataSource.performAction('deleteTeamLogo', team, { recordDescriptor: teamDescriptor }).then(updatedTeam => {
        this.setState({ team: updatedTeam });
      });
    }
    else {
      delete team.logo;
      this.setState({ team: team });
    }
  }

  setMarketUsers(markets) {
    if (markets) {
      let users = [];
      markets.forEach(market => {
        if (market.users) {
          market.users.forEach(user => {
            if (!users.find(u => { return user.id == u.id; })) {
              if (!user.suspended && (user.role.name == 'admin' || user.role.name == 'editor')) {
                users.push(user);
              }
            }
          });
        }
  
        // if (market.vendor_users) {
        //   market.vendor_users.forEach(user => {
        //     if (!users.find(u => { return user.id == u.id })) {
        //       if (!user.suspended && (user.role.name == 'admin' || user.role.name == 'editor')) {
        //         users.push(user)
        //       }
        //     }
        //   })
        // }
      });
      this.setState({ users });
      return users;
    }
  }

  showLogoPopup() {
    this.setState({ displayLogoPopup: true });
  }

  closeLogoPopup() {
    this.setState({ displayLogoPopup: false });
  }
  
  setTeamLogo(file, preview) {
    // this component depends on using a Data-URI for the logo,
    // thus preview is used instead of file (object)
    let team = this.state.team;
    team.logo = preview;
    let active = this.state.active;
    if (team.markets && team.markets.length > 0 && team.name) {
      active = true; 
    }
    this.setState({ team, active, logoChanged: true });
  }

  async setUsersWhoShareSameMarket(user){
    const sameMarketUsers =  await userService.getUserByMarket(user.primary_company_id, user.markets);
    this.setState({
      usersShareSameMarket: sameMarketUsers.data,
    });
  }

  deleteTeamLogo() {
    let team = this.state.team;
    let active = this.state.active;
    if (team.markets && team.markets.length > 0 && (!this.marketsEqual(team.markets, this.state.originalMarkets) || this.props.teamId) && team.name) {
      active = true; 
    }
    this.setState({ displayLogoPopup: false, active, logoChanged: true }, () => this.setTeamLogo(null, null));
  }

  expandPopup() {
    return anime({
      targets: this.deactivatePopup,
      height: this.props.currentUser.super_admin ? 414 : 364,
      easing: 'easeInOutCubic',
      duration: 200,
    });
  }

  collapsePopup(e, force) {
   
    return anime({
      targets: this.deactivatePopup,
      height: 0,
      easing: 'easeInOutCubic',
      duration: 100,
      complete: () => {
        this.closePopup();
      },
    });
    
  }
  
  queryCloseWithoutSave() {
    
    dataModel.showGlobalModal('SYSTEM_POPUP', {
      cancelButtonText: 'YES', 
      okButtonText: this.textMap.cancel,
      width: 300, 
      height: 175, 
      message: 'You haven\'t selected any user. Do you want to continue selecting a user?',
      handleOwnerOk: () => {
        this.collapsePopup(null, true);
      }, 
    });
  }

  closePopup() {
    dataModel.setDisableAppBackground(false);
    const { handleClosePopup } = this.props;
    if (handleClosePopup) {
      handleClosePopup();
    }
  }

  handleCreate(team) {
    this.analyticsLogger.logTeamEvent('TeamCreated');
    DataSource.create('Team', team, teamDescriptor, this.handleTeamRetrieval);
  }

  handleUpdateTeamMembers(team) {
    let selectedTabName = this.state.selectedTabName;
    if (!this.props.teamId) {
      selectedTabName = 'users';
    }
    if (this.state.updatedTeamUsers) {
      this.state.updatedTeamUsers.users.forEach(user => {
        if (user.toBeAdded) {
          delete user.toBeAdded;
          this.teamDataSource.performAction('addTeamUser', team, user.id, teamDescriptor);
        }
        else if (user.toBeRemoved) {
          delete user.toBeRemoved;
          this.teamDataSource.performAction('removeTeamUser', team, user.id, teamDescriptor);
        }
      });
    }
    this.setState({ selectedTabName });
  }

  handleUpdateTeamProjects(team) {
    let selectedTabName = this.state.selectedTabName;
    if (this.state.selectAllProjects) {
      this.analyticsLogger.logTeamEvent('TeamAddedToProjectViaTeam');
      this.teamDataSource.performAction('addTeamProject', team, 'all', this.state.projectManagers, this.state.projectTypes, teamDescriptor);
    }
    else {
      let toAdd = [];
      let toRemove = [];
      const assigned = teamAssignedProjects(team);
      if (assigned.length && this.state.selectedProjects) {
        assigned.forEach(project => {
          if (!this.state.selectedProjects.find(p => { return project.id == p; })) {
            toRemove.push(project.id);
          }
        });
      }
      if (this.state.selectedProjects) {
        this.state.selectedProjects.forEach(projectId => {
          if (!assigned.find(p => { return projectId == p.id; })) {
            toAdd.push(projectId);
          }
        });
      }
      toAdd.forEach(projectId => {
        this.analyticsLogger.logTeamEvent('TeamAddedToProjectViaTeam');
        this.teamDataSource.performAction('addTeamProject', team, projectId, teamDescriptor);
      });
      toRemove.forEach(projectId => {
        this.teamDataSource.performAction('removeTeamProject', team, projectId, teamDescriptor);
      });
    }

    this.setState({ selectedTabName });
  }

  handleUpdateTeam(team) {
    const updateTeam = Object.assign({}, team);
    let somethingChanged = 4;
    if (!this.state.marketsChanged || this.marketsEqual(updateTeam.markets, this.state.originalMarkets)) {
      delete updateTeam.markets;
      somethingChanged--;
    }
    if (!this.state.leadChanged) {
      delete updateTeam.lead_user;
    }
    else if (!updateTeam.lead_user) {
      updateTeam.remove_lead_user = true;
      somethingChanged--;
    }
    if (!this.state.logoChanged) {
      delete updateTeam.logo;
      somethingChanged--;
    }
    if (!this.state.nameChanged) {
      somethingChanged--;
    }
    if (somethingChanged) {
      this.analyticsLogger.logTeamEvent('TeamEdited');
      this.teamDataSource.update(updateTeam);
    }
    this.setState({ active: false, marketsChanged: false, nameChanged: false, logoChanged: false, leadChanged: false });
  }

  handleDeactivate(){
    if (this.state.selectedTabName == 'deactivate user'){
      this.setState({ selectedTabName: 'confirm deactivation',   deactivate: true, replace: false }); 
    }
    if(this.state.selectedTabName == 'confirm deactivation' && this.state.replace){
    
      this.setState({ selectedTabName: 'users',   deactivate: true }); 
    }
  }

  handleAcceptReplace(){
    this.setState({ selectedTabName: 'users', replace: true, deactivate: true }); 
    
  }

  handleNext() {
    const { team, active } = this.state;
    if (active) {
      if (!team.id) {
        this.handleCreate(team);
      }
      if (this.state.selectedTabName == 'confirm deactivation') {
        this.handleUpdateTeamMembers(team);
      }
      else if (this.state.selectedTabName == 'users') {
        this.handleUpdateTeamProjects(team);
      }
      else if (this.teamDataSource) {
        this.handleUpdateTeam(team);
      }
      if (!this.props.teamId) {
        this.handleAdvance();
      }
      else {
        this.closePopup();
      }
    }
    else if (!this.props.teamId) {
      this.handleAdvance();
    }
    else {
      this.closePopup();
    }
  }

  handleSave() {
    const {  deactivate, editedContact, replace, newUser } = this.state;
    if (deactivate) {
      if (replace && newUser==0){
        this.queryCloseWithoutSave();
      }
      else
      {
        this.doActivateSuspendUser(editedContact);
      
        this.setState({ deactivate: false });
        this.collapsePopup();
      }
     
    }
  } 

  doActivateSuspendUser(editedContact) {
    this.props.currentUser.suspended = true;
    this.props.currentUser.replacement_user_id= this.state.newUser;
    this.props.currentUser.newuser_rol=this.state.newUser_rol;
    dataModel.usersDAO.updateUser(this.props.currentUser).then((response) => {
      dataModel.setDisableAppBackground(false);
      window.location.reload();
      const { handleClosePopup } = this.props;
      if (handleClosePopup) {
        handleClosePopup();
      }
    });
  }

  handlePrev() {
    const { team, active } = this.state;
    if (active) {
      if (this.state.selectedTabName == 'confirm deactivation') {
        this.handleUpdateTeamMembers(team);
      }
      else if (this.state.selectedTabName == 'users') {
        this.handleUpdateTeamProjects(team);
      }
      else if (this.teamDataSource) {
        this.handleUpdateTeam(team);
      }
      if (!this.props.teamId) {
        this.handleAdvance(true);
      }
    }
    else if (!this.props.teamId) {
      this.handleAdvance(true);
    }
  }

  handleMarketChange(markets) {
    let team = this.state.team;
    team.markets = markets.map(market => {
      return market.market;
    });
    let active = this.state.active;
    const marketsChanged = !this.marketsEqual(team.markets, this.state.originalMarkets); 
    if (team.markets && team.markets.length > 0 && marketsChanged && team.name) {
      active = true; 
    }
    this.setState({ team, active, marketsChanged, resetProjects: true });
    const users = this.setMarketUsers(team.markets);
    if (marketsChanged && teamAssignedProjects(team).length) {
      this.setState({ selectedProjects: [] });
    }
    else {
      const assigned = teamAssignedProjects(team);
      if (assigned.length) {
        this.setState({ selectedProjects: assigned.map(project => { return project.id; }) });
      }
    }
    if (users && team.lead_user && !users.find(user => { return user.id == team.lead_user.id; })) {
      team.lead_user = null;
    }
  }

  handleLeadSelection(option, lead) {
    let team = this.state.team;
    let active = this.state.active;
    if (lead.selected) {
      team.lead_user = lead.user;
    }
    else {
      team.lead_user = null;
    }
    if (team.markets && team.markets.length > 0 && team.name) {
      active = true;
    }
    this.setState({ team, active, leadChanged: true });
  }

  changeTeamName(e) {
    let team = this.state.team; 
    team.name = e.target.value;
    let active = this.state.active;
    if (team.markets && team.markets.length > 0 && team.name) {
      active = true; 
    }
    this.setState({ team, active, nameChanged: true });
  }

  handleTabClick(tabName) {
    let active = this.state.active;
    if (!this.props.teamId) {
      const { team } = this.state;
      if (this.state.selectedTabName == 'confirm deactivation') {
        this.handleUpdateTeamMembers(team);
      }
      else if (this.state.selectedTabName == 'users') {
        this.handleUpdateTeamProjects(team);
      }
      else if (this.teamDataSource) {
        this.handleUpdateTeam(team);
      }
    }
    if (!this.props.teamId) {
      switch (tabName) {
      case 'deactivate user':
        active = true;
        break;
      case 'confirm deactivation':
        active = active || this.state.updatedTeamUsers || (this.state.team.users && this.state.team.users.length);
        break;
      case 'users':
        active = true;
        break;
      default:
        break;
      }
    }
    this.setState({ selectedTabName: tabName, active });
  }

  handleManageTeamUsers(updatedTeamUsers) {
    if (updatedTeamUsers.users.length > 0) {
      this.disabledTabs = [];
    }
    else {
      this.disabledTabs = ['users'];
    }
    let active = this.state.active;
    
    active = active || (updatedTeamUsers.users.filter(user => { return user.toBeAdded || user.toBeRemoved; }).length != 0);
    if (!this.props.teamId) {
      active = false;
      if (updatedTeamUsers.users) {
        updatedTeamUsers.users.forEach(user => {
          if (user.toBeAdded) {
            active = true;
          }
        });
      }
    }
    this.setState({ updatedTeamUsers, active });
  }

  handleManageTeamProjects(selectedProjects, selectAllProjects, projectManagers, projectTypes) {
    let active = this.state.active;
    if (!this.props.teamId) {
      active = true;
    }
    else {
      active = active || !this.projectsEqual(selectedProjects, teamAssignedProjects(this.state.originalTeam));
    }
    this.setState({ selectedProjects, active, selectAllProjects, projectManagers, projectTypes, resetProjects: false });
  }

  isAssignToProjectOrTask(user){
    if(user.active_tasks_count === 0 && user.active_projects_count === 0){
      return true;
    }
    return false;
  }

  handleDeactivateUser(visible) {
    const projectCount = this.props.currentUser.active_projects_count;
    const taskCount = this.props.currentUser.active_tasks_count;
    const userName = this.props.currentUser.name;

    return <div className={'deactivate-container'} style={{ display: visible ? 'flex' : 'none' }}>
    <div className='deactivate-info'>
    <p className='caption'> You are about to deactivate {userName}. {taskCount !== 0 || projectCount !== 0 ? `This user is assigned to ${taskCount} Tasks across ${projectCount} Projects.` : null} {this.props.isTeamLead ? `${userName} is team lead. You must replace the Team Leader ${userName} before they can be Deactivated.` : 'Would you like replace this user before deactivating them?'} </p>
 
    </div>
  </div>;
  }

  handleConfirmDeactivation(visible) {
    return <div className={'deactivate-container'} style={{ display: visible ? 'flex' : 'none' }}>
    <div className='deactivate-info'>
    <p className='caption'> Are you sure you wish to deactivate {this.props.currentUser.name}'s user account? All of this user's assignments will be removed and they will no longer have access to Active Oversight. </p>
 
    </div>
  </div>;
  }
  handleContactChanged(type, optionSelected) {
    let { editedContact } = this.state;
    if (optionSelected.selected) {
      let newUser_rol=optionSelected.user.role.name;
      editedContact.user = optionSelected.user;
      this.state.newUser=optionSelected.user.id;
      this.state.newUser_rol=newUser_rol;  
      this.setState({ changed: true, editedContact });
    }else{
      editedContact.user = null;
      this.state.newUser = 0;
      this.setState({ changed: false, editedContact });
    }
   
  }
 
  handleReplaceUser(visible) {
    const usertoDeactivate=this.props.currentUser;
    const userRoles = this.props.userRoles;
    let listUsers = [];

    if(this.state.usersShareSameMarket){
      this.state.usersShareSameMarket.forEach(user=>{
        const userRole = userRoles.find(role=> role.id === user.attributes.role_id);
        user.attributes.role = userRole;
        listUsers.push(user.attributes);
      });
    }

    return   <div className={'deactivate-container'} style={{ display: visible ? 'flex' : 'none' }}>
                <div className='deactivate-info'>
                <p className='caption'>Please select a user to replace {this.props.currentUser.name} with: </p>
                <p className='caption2'>Search with username if you can't find the intended user in the below dropdown list: (Only users with common markets can be replaced) </p>
                  <SelectUserComboBox 
                      users={listUsers}
                      menuHeight={200}
                      handleSelection={this.handleContactChanged}
                      currentSelectedUser={this.state.editedContact.user}
                      multiSelect={false}
                      small={true}
                      showSearchBar={true}
                      searchHint={'Search Directory'}
                      height={24}
                      width={240}
                      numberPerPage={this.props.numberPerPage}
                      autoFocusSearchBar={true}
                      editUserDetails={this.props.editUserDetails}
                      actualMarket={usertoDeactivate.markets}
                      usertoDeactivate={usertoDeactivate}
                      closeOnOutSideClick={true}
                    />
                </div>
            
            </div>;
  }

  render() {

    const logoAttachment = {
      upload: this.state.team.logo,
    };

    let teamDetails = null;
    let teamUsers = null;
    let teamProjects = null;
    if (this.state.selectedTabName == 'deactivate user') {
      teamDetails = this.handleDeactivateUser(true);
    }
    else {
      teamDetails = this.handleDeactivateUser(false);
    }
    if (this.state.selectedTabName == 'confirm deactivation') {
      teamUsers = this.handleConfirmDeactivation(true);
    }
    else {
      teamUsers = this.handleConfirmDeactivation(false);
    }
    if (this.state.selectedTabName == 'users' && this.state.replace) {
      teamProjects = this.handleReplaceUser(true);
    }
    else {
      teamProjects = this.handleReplaceUser(false);
    }
    // let nextCaption = this.state.replace ? 'NEXT' : "SAVE"
    let deactivateCaption = !this.state.deactivate ? 'No' : 'DEACTIVATE';
    if (this.state.selectedTabName == 'users' && this.state.replace) {
      deactivateCaption = 'REPLACE & DEACTIVATE';
    }

    let isNoButtonEnabled = true;
    if(this.state.selectedTabName == 'users' && this.state.replace){
      isNoButtonEnabled = true;
    }
    else{
      if(this.props.isTeamLead){
        isNoButtonEnabled = false;
      }
    }

    return (
      <article
        className='deactivate-popout'
        ref={el => this.deactivatePopup = el}
        style={!isNoButtonEnabled && this.isAssignToProjectOrTask(this.props.currentUser) ? { height: '220px' } : null}
      >
        {
          this.state.displayLogoPopup &&
          <div className="company-crud__logo-popup">
            <PhotoCarousel
              attachments={[logoAttachment]}
              hasRename={false}
              hasDelete={true}
              parentDelete={true}
              handleDelete={this.handleDeleteLogo}
              handleClose={this.closeLogoPopup}
            />
          </div>
        }

        <header className='team-popout__header' 
        style={{ backgroundColor: '#184E78' }}>
          <div className='caption'  style={{ color: 'white' }}>
            {this.popupCaption}
            </div>
          <div className='close-button'>
            <img
              src={cancelIcon}
              alt="cancel"
              className='close-button'
              onClick={this.collapsePopup}
            />
          </div>
        </header>
        {/* <TabbedPageControl
          tabItems={this.tabs}
          disabledItems={this.disabledTabs}
          selectedTabName={this.state.selectedTabName}
          handleClick={this.handleTabClick}
        /> */}
        <section className='deactivate-popout__container'>
          {teamDetails}
          {teamUsers}
          {teamProjects}
        </section>
        <div className='deactivate-popout__button-container'>
         
        <button
          className={'cancel-button'}
            onClick={this.collapsePopup}
            style={!isNoButtonEnabled ? { right: '135px' } : null}
          >
          CANCEL
        </button> 
        
         { isNoButtonEnabled ?
            <button
              className={'deactivate-button'  + (this.state.deactivate ? ' active' : '') }
              style={{ width: this.state.deactivate  || this.state.selectedTabName  == 'users' ? '95px' :'56px' , 
              right: this.state.deactivate || this.state.selectedTabName  == 'users'? '90px' :'125px',
              height: this.state.selectedTabName  == 'users'?'40px': '32px' }}
              onClick={this.state.selectedTabName == 'users' || 
              (this.state.selectedTabName == 'confirm deactivation' && !this.state.replace) ? this.handleSave : this.handleDeactivate}
            >
              {deactivateCaption}
            </button>
            :
            null
          }

          {
            this.state.replace == null ? <button className={'next-button'}  onClick={this.handleAcceptReplace} >
            Yes
          </button> : null
            
          }
         
        </div>
      </article>
    );
  }

}

const mapStateToProps = (state, ownProps) => {
  return {
    userRoles: state.new_users.userRoles,
  };
};

export default connect(mapStateToProps)(DeactivateUserPopup);




// WEBPACK FOOTER //
// ./src/components/DeactivateUserPopup/index.js